// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2jLfp","footer":"Form_footer__1nZuH"};